import React from 'react';
import { Github, Linkedin, Mail, Heart } from 'lucide-react';
import { consultantInfo } from '../mock';

const footerLinks = [
  { label: 'About', href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Contact', href: '#contact' },
];

const Footer = () => {
  const year = new Date().getFullYear();

  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800/60">
      {/* Top section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">

          {/* Brand */}
          <div className="space-y-4">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-3xl font-bold text-white hover:text-emerald-400 transition-colors"
            >
              Akshay<span className="bg-gradient-to-r from-emerald-400 to-violet-400 bg-clip-text text-transparent">.</span>
            </button>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              Engineer by profession. Teacher by passion.<br />
              Open source enthusiast from Pune, India.
            </p>
            <div className="flex gap-3 pt-1">
              {[
                { href: 'https://github.com/akshay-sonalkar', icon: Github, label: 'GitHub' },
                { href: `https://${consultantInfo.linkedin}`, icon: Linkedin, label: 'LinkedIn' },
                { href: `mailto:${consultantInfo.email}`, icon: Mail, label: 'Email' },
              ].map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target={href.startsWith('mailto') ? undefined : '_blank'}
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-lg bg-slate-900 border border-slate-800 hover:border-emerald-500/40 hover:bg-slate-800 flex items-center justify-center text-slate-400 hover:text-emerald-400 transition-all duration-200"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="text-xs text-slate-500 uppercase tracking-widest font-mono mb-5">Navigation</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    className="text-sm text-slate-400 hover:text-emerald-400 transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="w-0 h-px bg-emerald-400 group-hover:w-3 transition-all duration-200" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs text-slate-500 uppercase tracking-widest font-mono mb-5">Get In Touch</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${consultantInfo.email}`}
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors duration-200 break-all"
                >
                  {consultantInfo.email}
                </a>
              </li>
              <li className="text-sm text-slate-500">{consultantInfo.location}</li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-slate-500">
            © {year} {consultantInfo.name}. All rights reserved.
          </p>
          <p className="text-xs text-slate-600 flex items-center gap-1.5">
            Built with <Heart className="w-3 h-3 text-rose-500" /> and open source tools.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
